module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C415"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "C453"
  }, [_c('strong', [_vm._v("Maps and diagrams")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#page_16"
    }
  }, [_vm._v("Palestine in New Testament times ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#id_187"
    }
  }, [_vm._v("Jerusalem at the time of Jesus ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09_2Judaism_in_first_century_Palest#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Temple Mount AD 70 ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09_2Judaism_in_first_century_Palest#id_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Herodian temple area ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_13Acts#id_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s first journey ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_13Acts#id_190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s second journey ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_13Acts#id_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s third journey ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_13Acts#id_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s journey to Rome ")])]), _vm._v(" "), _c('p', {
    staticClass: "C453"
  }, [_c('strong', [_vm._v("Charts and tables")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#page_8"
    }
  }, [_vm._v("Key dates and events in the second temple period ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#id_193"
    }
  }, [_vm._v("Key dates from the OT to the Roman takeover ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#id_194"
    }
  }, [_vm._v("Hasmonean leaders of Judea 167-63 BC ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#id_195"
    }
  }, [_vm._v("Herod family: a selective family tree ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#id_196"
    }
  }, [_vm._v("Leaders/rulers of Judea in the Roman period ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#id_197"
    }
  }, [_vm._v("Roman leaders/emperors ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#id_198"
    }
  }, [_vm._v("Key dates in the Roman period ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_4Where_did_the_Gospels_come_from#id_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Agreements in sequence: an example ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_4Where_did_the_Gospels_come_from#id_200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The sequence of Q ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_4Where_did_the_Gospels_come_from#id_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew’s sermon on the mount material in Luke")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_4Where_did_the_Gospels_come_from#id_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alternating support: an example ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_10Matthew#id_203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon on the mount ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_11Luke#id_204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke and his sources ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_13Acts#id_205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecy and fulfilment: some examples")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_13Acts#id_206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acts as fulfilment of 1:8 ")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_13Acts#page_336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A chronological outline of Acts ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f32c73c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_List_of_illustrations.vue
// module id = 66
// module chunks = 0